import type { PropsWithChildren } from 'react'

import { ExpiringFansQueryProvider } from '@/modules/expiring-fans/query/expiring-fans-query-context'
import { DefaultExpiringFansProvider } from '@/modules/expiring-fans/service/expiring-fans-fetch-context'
import { ExpiringFansFilterProvider } from '@/modules/expiring-fans/use-expiring-fans-filter.tsx'
import { MessageMediaQueryProvider } from '@/modules/message/query/message-media-query-context.tsx'
import { DefaultMessageMediaProvider } from '@/modules/message/service/message-fetch-context.tsx'
import { PaginationProvider } from '@/utils/pagination/pagination-context.tsx'

export const ExpiringFansModule = ({ children }: PropsWithChildren) => {
  return (
    <PaginationProvider>
      <ExpiringFansFilterProvider>
        <DefaultExpiringFansProvider>
          <DefaultMessageMediaProvider>
            <MessageMediaQueryProvider>
              <ExpiringFansQueryProvider>{children}</ExpiringFansQueryProvider>
            </MessageMediaQueryProvider>
          </DefaultMessageMediaProvider>
        </DefaultExpiringFansProvider>
      </ExpiringFansFilterProvider>
    </PaginationProvider>
  )
}
